import { render, staticRenderFns } from "./BaseAdminPage.vue?vue&type=template&id=937ef30a&scoped=true&"
import script from "./BaseAdminPage.vue?vue&type=script&lang=js&"
export * from "./BaseAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937ef30a",
  null
  
)

export default component.exports